import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const RentToOwnBusinessExecSummary = ({ investorResult, yearlyData, params }) => {
  if (!investorResult || !yearlyData) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="bg-purple-50 p-6 rounded-lg space-y-2">
      <ul className="list-disc list-inside text-gray-700 text-sm space-y-1">
        <li><strong>Term:</strong> {params.termYears} Years</li>
        <li><strong>Asset Start:</strong> {formatCurrency(params.propertyValue)}</li>
        <li><strong>Rent Start:</strong> {formatCurrency(Math.round(params.propertyValue / 180))}/month</li>
        <li><strong>Rent Growth:</strong> {params.rentGrowthRate}% annually</li>
        <li><strong>Business Revenue Growth:</strong> {params.businessRevenueGrowthRate}%</li>
        <li><strong>Business Multiplier:</strong> {params.businessAppreciationMultiple}x</li>
        <li><strong>Total Rent Paid:</strong> {formatCurrency(investorResult.totalBorrowerPaid)}</li>
        <li><strong>Equity Built:</strong> {formatCurrency(investorResult.equityBuilt)}</li>
        <li><strong>Final Asset Value:</strong> {formatCurrency(investorResult.finalValue)}</li>
        <li><strong>Business Value at Exit:</strong> {formatCurrency(investorResult.businessValue)}</li>
        <li><strong>Net Cashflow:</strong> {formatCurrency(investorResult.netCashflow)}</li>
        <li><strong>Total ROI:</strong> {investorResult.totalROI}%</li>
        <li><strong>Annualized ROI:</strong> {investorResult.annualizedROI}%</li>
      </ul>
    </div>
  );
};

export default RentToOwnBusinessExecSummary;
